// EmptyState — centred placeholder for lists/tables that have no
// rows. Title + optional description + optional action (typically a
// Button). Avoids the "is this loading or empty?" ambiguity by
// making emptiness explicit.
//
// Optional `icon` prop: when supplied, renders the icon at 64px above
// the title inside a 96px Spring Wood circle with brand-deep tint.

import type { ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  description?: string
  action?: ReactNode
  /** Optional icon (e.g. a Lucide component at 32px). Rendered above the
   *  title in a Spring Wood circle with brand-deep tint when provided. */
  icon?: ReactNode
}

export function EmptyState({ title, description, action, icon }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-md border border-dashed border-gray-300 bg-white p-8 text-center">
      {icon !== undefined ? (
        <div className="mb-2 flex h-24 w-24 items-center justify-center rounded-full bg-surface text-brand-deep">
          {icon}
        </div>
      ) : null}
      <h2 className="text-base font-semibold text-gray-900">{title}</h2>
      {description !== undefined ? (
        <p className="max-w-md text-sm text-gray-600">{description}</p>
      ) : null}
      {action !== undefined ? <div className="mt-2">{action}</div> : null}
    </div>
  )
}
